import AjaxErrorMixin from '../mixins/ajax-errors';
import {Message} from 'element-ui';

class VoiceService {
  /**
   * @param {string} sid
   * @param {number} audioId
   * @return {Promise}
   */
  mail(sid, audioId) {
    const url = config('voice.mail.url');
    if (!url) {
      return Promise.resolve(false);
    }

    return axios.post(url, {sid, audio_id: audioId})
      .then(({data: {message}}) => {
        Message.success(message);

        return true;
      })
      .catch((err) => {
        this.handleErrorResponse(err, Message);

        return false;
      });
  }
}

Object.assign(VoiceService.prototype, AjaxErrorMixin.methods);

export default VoiceService;